var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c(
        "div",
        { staticClass: "search-box", style: _vm.boxStyle },
        [
          _vm.configObj.searConfig.tabVal === 0
            ? [
                _vm.configObj.logoConfig.isShow === 1 && _vm.logoUrl
                  ? _c("img", {
                      staticClass: "logo-img",
                      attrs: { src: _vm.logoUrl, alt: "" },
                    })
                  : _vm._e(),
                _c("div", { staticClass: "box", style: _vm.contentStyle }, [
                  _c("span", { staticClass: "line1" }, [
                    _c("i", { staticClass: "el-icon-search" }),
                    _c("span", [_vm._v(_vm._s(_vm.hotWord))]),
                  ]),
                ]),
                _vm._m(0),
              ]
            : _vm.configObj.searConfig.tabVal === 1
            ? [
                _vm.logoUrl
                  ? _c("img", {
                      staticClass: "logo-img",
                      attrs: { src: _vm.logoUrl, alt: "" },
                    })
                  : _vm._e(),
                _c("div", { staticClass: "box", style: _vm.contentStyle }, [
                  _c("span", { staticClass: "line1" }, [
                    _c("i", { staticClass: "el-icon-search" }),
                    _c("span", [_vm._v(_vm._s(_vm.hotWord))]),
                  ]),
                ]),
              ]
            : _vm.configObj.searConfig.tabVal === 2
            ? [
                _c(
                  "div",
                  { staticClass: "fudou-search-box", style: _vm.fudouBoxStyle },
                  [
                    _c("i", {
                      staticClass: "el-icon-search fudou-search-icon",
                    }),
                    _c("span", { staticClass: "fudou-search-text" }, [
                      _vm._v(_vm._s(_vm.placeWordsText)),
                    ]),
                    _c("div", { staticClass: "fudou-search-btn" }, [
                      _vm._v("有福"),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "capsule" }, [
      _c("img", {
        attrs: { src: require("@/assets/imgs/capsule.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }